import { faSearch, faUndo } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import Button from 'shared/button';
import { Empty } from '@buildoutinc/blueprint-react/ui/Empty';
import PropTypes from 'prop-types';

export default function LeadNoResults({ onClearFilters }) {
  return (
    <Empty className="bg-white">
      <Empty.Media>
        <FontAwesomeIcon icon={faSearch} />
      </Empty.Media>
      <Empty.Title>No results found</Empty.Title>
      <Empty.Content>Search with different criteria or reset filters</Empty.Content>
      <Empty.Actions>
        <Button.Primary icon={faUndo} label="Reset Filters" plain onClick={onClearFilters} />
      </Empty.Actions>
    </Empty>
  );
}

LeadNoResults.propTypes = {
  onClearFilters: PropTypes.func.isRequired
};
